<template>
    <!-- Configuración de países -->

    <div class="d-block mb-1">
        <label v-if="useTitle">{{ title }}</label>
        <el-select placeholder="Seleccionar variable configurable" clearable collapse-tags-tooltip v-model="model" @input="inputChangeModelValue"
            @clear="onHandleClearConfigsVariables($event)"
            @change="onHandleChnageConfigsVariables($event)"
            @focus="onHandleFocusInputConfigsVariables($event)" filterable no-data-text="No hay resultados para mostrar."
            no-match-text="No hay resultados para mostrar." :remote-method="searchItemToListByParams" remote
            :class="customClass"
        >
            <el-option-group v-for="group in getConfigurableVariablesInGroups" :key="group.title" :label="group.title">
                <el-option v-for="item in group.items" :key="item.id" :label="getTitleToVariableConfigurable(item)"
                    :value="item.id" />
            </el-option-group>
        </el-select>
    </div>
</template>

<script>

// Importaciones generales
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    name: 'selectConfigVarsCompany',
    props: {
        companyId: {
            type: [Number, String],
            default: 0
        },
        useTitle: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Configurar datos del país para las etiquetas'
        },
        customClass: {
            type: String,
            default: ''
        },
        clearAfterSelected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // alamacena el id de la vaiable configurable para el usuario
            values: [],
            valuesTemporary: [],
            filtered: false,
            model: ''
        };
    },
    created() {
        /**
         * Cargar las Configuración de países.
         * @author Fernando Claros
         */
        this.getConfigurableVariables(this.companyId);
    },
    computed: {
        // Estados del modulo Configuración de países
        ...mapState('configurableVariables', [
            'filter',
            'configurableVariables',
            'defaultConfigurableVariable'
        ]),
        /**
         * Cargar las Configuración de países.
         * @author Fernando Claros
         */
        getConfigurableVariablesInGroups() {
            if (!this.filtered) this.valuesTemporary = this.configurableVariables;

            return this.groupByConfigurableVariables(this.configurableVariables);
        },
    },
    methods: {
        // Metodos del modulo Configuración de países
        ...mapActions('configurableVariables', [
            'loadConfigurableVariables'
        ]),
        // Mutaciones del modulo Configuración de países
        ...mapMutations('configurableVariables', ['setConfigurableVariables']),
        inputChangeModelValue(selectedValue = '') {
            this.model = selectedValue
            this.$emit("inputChange", selectedValue);

            if (this.clearAfterSelected) this.model = ''
        },
        onHandleChnageConfigsVariables(selectedValue = '') {
            this.inputChangeModelValue(selectedValue);
        },
        /**
         * Cargar las Configuración de países.
         * 
         * @author Fernando Claros
         */
        async getConfigurableVariables(companyId) {

            // Limpiar datos anteriores
            this.valuesTemporary = []
            this.setConfigurableVariables([]);

            const payload = {
                companyId,
                page: 0,
                pagination: 0,
                status: 1
            };
            await this.loadConfigurableVariables(payload)
        },
        /**
         * Limpiar el buscador y restablecer la información inicial.
         * 
         * @author Fernando Claros
         */
        onHandleClearConfigsVariables() {
            this.values = []
            this.setConfigurableVariables(this.valuesTemporary);
        },
        /**
         * Creacion de la data para el select agrupado.
         * 
         * @param Array items 
         * @author Fernando Claros
         */
        groupByConfigurableVariables(items = []) {
            try {

                // Creacion de los grupos
                let groups = [];
                items.map(item => groups.find(group => group.key === item.slq_country_id) ? null : groups.push({ key: item.slq_country_id, title: `${item.country.name} (${item.country.code})`, items: [] }));

                // Asignar los items a su grupo respectivo
                return groups.map(group => {
                    group.items = items.filter(item => item.slq_country_id === group.key)
                    return group;
                });

            } catch ($e) {
                return [];
            }
        },
        /**
         * Crear titulo para ver en el selector de Configuración de países.
         * 
         * @param String item: ítem activo
         * @author Fernando Claros
         */
        getTitleToVariableConfigurable(item) {
            const language = ('languague' in item) ? ('lista' in item.languague ? item.languague.lista : '') : '';

            return `Teléfono: ${item.phone_code ? item.phone_code : ''} ${item.phone}, (${language})`;
        },
        /**
         * Buscar ítems del listado.
         * 
         * @param String query 
         * @author Fernando Claros
         */
        searchItemToListByParams(query) {

            // NO se ingreso un parametro de busqueda valido.
            if (!query || query.length < 4) {
                this.onHandleClearConfigsVariables();
                return false;
            }

            // Buscar
            this.filtered = true;
            this.values = this.configurableVariables.filter((item) => {
                return `${item.phone} ${item.phone_code} ${item.country.name} ${item.languague.lista}`.toString().toLowerCase().includes(query.toLowerCase())
            })

            // Setear las nuevas opciones disponibles en el listado.
            this.setConfigurableVariables(this.values);

        },
        onHandleFocusInputConfigsVariables() {
            this.setConfigurableVariables(this.valuesTemporary);
        }
    },
}
</script>

<style scoped></style>